import { Dialog, DialogTitle, DialogContent, DialogActions, Button, DialogContentText, Grid, MenuItem } from '@mui/material';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';
import * as yup from 'yup';
import { Form, Field, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { Locale } from 'helpers/Enums';

interface IProps {
    ticketId: string
    ticketCustomer: ITicketCustomer

    onClose: (refresh: boolean) => void
}

interface ITicketCustomer {
    customerId: number
    customerName: string
}

export let reporterSchema = yup.object().shape({
    id: yup.string().default('').nullable(),
    email: yup.string().default('').required().label("Email"),
    firstName: yup.string().default('').required().label("First name"),
    lastName: yup.string().default('').required().label("Last name"),
    language: yup.string().default('').required().label("Language"),
});

type IReporter = yup.InferType<typeof reporterSchema>;


let CreateReporter = ({ ticketId, ticketCustomer, onClose }: IProps) => {
    let { formatMessage } = useIntl();
    let { enqueueSnackbar } = useSnackbar();


    let closeAndConfirm = async (reporter: IReporter) => {
        try {
            let request = {
                ...reporter,
                ticketId,
                customerId: ticketCustomer?.customerId ?? 0,
                customerName: ticketCustomer?.customerName ?? ''
            }

            await axios.post('/api/Customer/CreateReporter', request);
            enqueueSnackbar(formatMessage({ id: LocalizationIds.SavedReporter }), { variant: "success" });
            onClose(true);

        } catch (err) { }
    }


    return (
        <Dialog open={true} onClose={() => onClose(false)} fullWidth>
            <DialogTitle>
                {formatMessage({ id: LocalizationIds.CreateReporter })}
            </DialogTitle>
            <Formik
                enableReinitialize={true}
                initialValues={reporterSchema.getDefault()}
                validationSchema={reporterSchema}
                onSubmit={(values, action) => {
                    closeAndConfirm(values);
                    action.setSubmitting(false);;
                }}
            >
                <Form>
                    <DialogContent>
                        <DialogContentText>
                            {formatMessage({ id: LocalizationIds.CreateReporterTitle })}.
                        </DialogContentText>

                        <Grid container>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    name="email"
                                    type="email"
                                    label={formatMessage({ id: LocalizationIds.Email })}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Field
                                    component={TextField}
                                    name="firstName"
                                    label={formatMessage({ id: LocalizationIds.FirstName })}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Field
                                    component={TextField}
                                    name="lastName"
                                    label={formatMessage({ id: LocalizationIds.LastName })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    select
                                    name="language"
                                    label={formatMessage({ id: LocalizationIds.Language })}
                                    size="small"
                                >
                                    <MenuItem key={Locale.Italian} value={Locale.Italian}>
                                        {formatMessage({ id: LocalizationIds.Italian })}
                                    </MenuItem>
                                    <MenuItem key={Locale.English} value={Locale.English}>
                                        {formatMessage({ id: LocalizationIds.English })}
                                    </MenuItem>
                                </Field>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    <DialogActions>
                        <Button type="button" onClick={() => onClose(false)} color="secondary">
                            {formatMessage({ id: LocalizationIds.Cancel })}
                        </Button>
                        <Button type="submit" autoFocus>
                            {formatMessage({ id: LocalizationIds.Confirm })}
                        </Button>
                    </DialogActions>
                </Form>
            </Formik>
        </Dialog>
    )
}

export default CreateReporter;